import { useContext } from 'react';
import LocalizationContext from '../contexts/localizationContext'

const useLocalization = () => {
  const context = useContext(LocalizationContext);
  if (!context) {
    throw new Error('useLocalization deve essere usato all\'interno di LocalizationProvider');
  }
  return context;
};

export { useLocalization }